/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Constants } from '../../core/Constants';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { IOasParameterParent } from '../../openapi/models/IOasParameterParent';
import { OasParameter } from '../../openapi/models/OasParameter';

/**
 * A command used to delete a single parameter from an operation.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteParameterCommand extends AbstractCommand {
    public _parameterPath : NodePath;

    public _parentPath : NodePath;

    public _oldParameter : any;

    public constructor(parameter? : any) {
        if(((parameter != null && parameter instanceof <any>OasParameter) || parameter === null)) {
            let __args = arguments;
            super();
            if(this._parameterPath===undefined) this._parameterPath = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldParameter===undefined) this._oldParameter = null;
            if(this._parameterPath===undefined) this._parameterPath = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldParameter===undefined) this._oldParameter = null;
            (() => {
                this._parameterPath = Library.createNodePath(parameter);
                this._parentPath = Library.createNodePath(parameter.parent());
            })();
        } else if(parameter === undefined) {
            let __args = arguments;
            super();
            if(this._parameterPath===undefined) this._parameterPath = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldParameter===undefined) this._oldParameter = null;
            if(this._parameterPath===undefined) this._parameterPath = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldParameter===undefined) this._oldParameter = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteParameterCommand] Executing.");
        this._oldParameter = null;
        let param : OasParameter = <OasParameter>this._parameterPath.resolve(document);
        if(this.isNullOrUndefined(param)) {
            return;
        }
        let parent : IOasParameterParent = <IOasParameterParent><any>param.parent();
        let parameters : Array<OasParameter> = parent.getParameters();
        let idx : number = parameters.indexOf(param);
        if(idx === -1) {
            return;
        }
        /* remove */parameters.splice(idx, 1)[0];
        this._oldParameter = Library.writeNode(param);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteParameterCommand] Reverting.");
        if(this.isNullOrUndefined(this._oldParameter)) {
            return;
        }
        let parent : IOasParameterParent = <IOasParameterParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let parameters : Array<OasParameter> = parent.getParameters();
        if(this.isNullOrUndefined(parameters)) {
            parameters = <any>([]);
            NodeCompat.setProperty(parent, Constants.PROP_PARAMETERS, parameters);
        }
        let param : OasParameter = parent.createParameter();
        Library.readNode(this._oldParameter, param);
        parent.addParameter(param);
    }
}
DeleteParameterCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteParameterCommand";
DeleteParameterCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];





import { MarshallCompat } from '../../compat/MarshallCompat';

